import _ from 'lodash';
import { IntentLabelConfig } from 'v2/modules/withRunForm/configs/index';

export const intentIdIntializer = (cases, pipeConfigs) => {
  const caseLegIds = {};
  const loopIntents = (intents, caseIndex) => {
    _.each(intents, (intent) => {
      caseLegIds[caseIndex] = caseLegIds[caseIndex] || [];
      caseLegIds[caseIndex].push(intent?.identifier?.label);
    });
  };
  _.each(cases, (caseConfig, caseIndex) => {
    const { entry: { intents }, adjustments } = caseConfig;
    loopIntents(intents, caseIndex);
    _.each(adjustments, ({ intents: adjustmentIntents }) => {
      loopIntents(adjustmentIntents, caseIndex);
    });
  });

  _.each(pipeConfigs, (pipeConfig) => {
    const intents = _.get(pipeConfig, 'config.legs', []);
    _.each(intents, (intent) => {
      IntentLabelConfig.setConfigNameAndValue(pipeConfig?.name, intent?.identifier?.label);
    });
  });

  _.each(caseLegIds, (legIds, caseIndex) => {
    const numericLegIds = _.map(legIds, Number);
    IntentLabelConfig.setConfigNameAndValue(caseIndex, _.max(numericLegIds) || 0);
  });
};
